import useTypedSWR from 'src/components/general/useTypedSWR';
import { GET_REQUEST_QUERY } from 'src/dropInClinic/queries/getPicRequest.gql';

export const useGetPicRequest = (requestId: string) => {
  const { data, error, isLoading, mutate } = useTypedSWR([GET_REQUEST_QUERY, { requestId }]);

  return { data, error, isLoading, mutate };
};
